import script from "./Login.vue?vue&type=script&setup=true&lang=ts"
export * from "./Login.vue?vue&type=script&setup=true&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=124135a6&lang=scss&scoped=true"
import "./Login.vue?vue&type=style&index=1&id=124135a6&lang=scss&scoped=true"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124135a6"]])

export default __exports__